import React, { Component,useCallback } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Input, Col, Row, Button, message } from 'antd'
import * as actions  from '@/models/notifies/services'
import Upload from '../CreateOrderDialog/Upload';
import styles from './notify.module.scss'
import UploadFiles from '../ProductInfoDialog/UploadFiles';
import dayjs from 'dayjs';
import { previewImage } from 'antd/lib/upload/utils';
const { TextArea } = Input;

@Form.create()
class NotifyDialog extends Component {
  state = {
    loading: false,
  }
 
  handleSubmit = e => {
    const { notify = {}, ismodify, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      this.setState({ loading: true })
      if (ismodify !== "modify") {
        actions.addNotify({
          title: values.title,
          content: values.content,
          images: values.images,
          files: values.files
        }).then(result => {
          message.success('添加成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      } else {
        actions.updateNotify(notify._id, {
          title: values.title,
          content: values.content,
          images: values.images,
          files: values.files
        }).then(result => {
          message.success('修改成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      }
    });
  }
  componentDidMount() {

  }
  preview(e){
    let url = e.target.getAttribute('data-url');
    let height = e.target.getAttribute('data-height');
    let width = e.target.getAttribute('data-width');
    let location = `${url}?x-oss-process=image/resize,m_fill,h_${height},w_${width}/format,webp`
    window.open(location);
  }
  previewPdf(e){
    let url = e.target.getAttribute('data-url');
    window.open(url);
  }
  render() {
    const {  notify = {},disabled,review } = this.props
    const { getFieldDecorator } = this.props.form
    //const disabled = this.state.loading
    const formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      }
    return (
      <div>
        {review && (<>
        <div style={{textAlign:"center"}}>
        <h2>{notify.title}</h2>
        <h5>{dayjs(notify.createAt).format('YYYY-MM-DD  HH:mm:ss')}</h5>
        </div>
        <div style={{marginTop:20}}>
        <span style={{whiteSpace:"pre-line"}}>{notify.content}</span>
        <div className={styles.list}>
        {
          notify.images?.map(item => (
            <div key={item.id} className={styles.item}>
              <a><img onClick={this.preview} data-url={item.url} data-width={item.dimensions.width} data-height={item.dimensions.height}  className={styles.img} src={item.url + '?x-oss-process=image/resize,m_fill,h_100,w_100/format,webp'}/></a>
            </div>
          ))
        }
        </div>
        {notify.files?.length>0 && (
        <div className={styles.list}>
        附件：
        {
          notify.files?.map(item => (
          <a key={item.id} style={{marginLeft:"10px"}} onClick={this.previewPdf} data-url={item.url}  src={item.url}>{item.originalname}</a>
          ))
        }
        </div>)}
      </div>
        </>)}
        {!review && (
        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
          <Row>
            <Col span={24}>
              <Form.Item 
                label="标题"
                required>
                {getFieldDecorator('title', {
                  initialValue: notify.title,
                  rules: [
                    {
                      required: true,
                      message: '请输入标题',
                    },
                  ],
                })(
                  <Input disabled={disabled} style={{ width: 300 }} placeholder="请输入标题" />
                )}
              </Form.Item>
              <Form.Item 
                label="消息正文"
                required>
                {getFieldDecorator('content', {
                  initialValue: notify.content,
                  rules: [
                    {
                      required: true,
                      message: '请输入消息正文',
                    },
                  ],
                })(
                  <TextArea disabled ={disabled} style={{ width: 300 }}  rows={8}  placeholder="请输入消息正文" />
                )}
              </Form.Item>
              <Form.Item label="图片">
            {getFieldDecorator('images', {
              initialValue: notify?.images,
            })(<Upload />)}
            </Form.Item>
            <Form.Item {...formItemLayout}
              label="附件文档"> {
                getFieldDecorator('files', {
                initialValue: notify?.files,
                rules: [
                  {
                    required: false,
                    message: '请上传附件文档',
                  },
                ],
              })(
                <UploadFiles disabled={disabled}>
                </UploadFiles>
                )}
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col style={{textAlign:"center"}}>
                  <Button type="primary" disabled={disabled} htmlType="submit">保存消息</Button>
              </Col>
          </Row>
        </Form>
        )}
      </div>
    )
  }
}

const NotifyInfoDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={600}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <NotifyDialog onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'NOTIFY_DIALOG',
})(NotifyInfoDialog)
